import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function Navbar() {
  const { count } = useCart();

  return (
    <nav style={{position:'fixed',top:0,left:0,right:0,background:'#0D1B2A',padding:'0 40px',height:64,display:'flex',alignItems:'center',justifyContent:'space-between',zIndex:100}}>
      <Link to="/" style={{color:'#fff',fontWeight:700,fontSize:20,textDecoration:'none'}}>
        Rocca <span style={{color:'#C9A84C'}}>B2B</span>
      </Link>
      <div style={{display:'flex',gap:24,alignItems:'center'}}>
        <Link to="/catalog" style={{color:'rgba(255,255,255,0.75)',textDecoration:'none',fontSize:14}}>Каталог</Link>
        <Link to="/cart" style={{color:'rgba(255,255,255,0.75)',textDecoration:'none',fontSize:14,position:'relative'}}>
          🛒 Кошик
          {count > 0 && (
            <span style={{position:'absolute',top:-8,right:-12,background:'#C9A84C',color:'#0D1B2A',borderRadius:'50%',width:18,height:18,fontSize:11,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>
              {count}
            </span>
          )}
        </Link>
        <Link to="/cabinet" style={{color:'rgba(255,255,255,0.75)',textDecoration:'none',fontSize:14}}>Кабінет</Link>
      </div>
    </nav>
  );
}

export default Navbar;
